import React from "react";
import { connect } from "react-redux";

import MaterialSpinner from "../../ui/materialSpinner";
import LookListMainFeature from "./lookListMainFeature";
import {sortCartItemsForListPage} from "../lookNavigation/lookFunctions2";
import LookPolicyLinks from "../lookPolicyLinks";

const LookListMain = (props) => {

  const {visualizersLoadedLength, cartItems, isMobile} = props;

  if (!visualizersLoadedLength) {
    return (
      <div className="ll-main">
        <MaterialSpinner/>
      </div>
    )
  }

  const cartItemsList = sortCartItemsForListPage(cartItems)

  return (
    <div className="ll-main">
      <ul className="ll-main__list">
        {cartItemsList.map(cartItem => {
          return <LookListMainFeature cartItem={cartItem} key={cartItem.id}/>
        })}
      </ul>
      {isMobile ? <LookPolicyLinks position={"center"} isSimple={true}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, isMobile} = store.serverState;
  const {cartItems} = store.cartState;
  return {
    visualizersLoadedLength: visualizersLoaded.length,
    cartItems,
    isMobile,
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(LookListMain)
